export const MODE_POINTS = [
  'InvStatus',
  'RunMode',
  'AllowedMinP',
  'AllowedMaxP',
  'AllowedMinQ',
  'AllowedMaxQ',
  'PCS_P',
  'PCS_Q',
];
